module.exports = __webpack_public_path__ + "static/media/renault.2c920ae2.svg";